import { ApolloLink } from '@apollo/client';
import noRetryOperations from './noRetryOperations';

const operationHasMutations = (operation: any) => {
  return operation.query.definitions.some((def: any) => {
    return def.kind === 'OperationDefinition' && def.operation === 'mutation';
  });
};

// this code will elevate graphql errors to network errors so they can be retried
// https://github.com/apollographql/apollo-link/issues/541
const elevateGqlErrorsLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    const errors = response['errors'];

    if (response && errors && errors.length > 0) {
      /**
       * Handles partial success in the GraphQL response by detecting errors with
       * `extensions.failedTenants` or those queries on the noRetry list.
       * Ensures both `data` and error details are returned, allowing
       * to process successful data while notifying users of failures. Prevents
       * `elevateGqlErrorsLink` from throwing and blocking access to valid data.
       */
      const partialSuccessError =
        errors.find((error) => error.extensions?.failedTenants) ||
        (operation.operationName &&
          noRetryOperations.includes(operation.operationName));

      if (partialSuccessError) {
        return response;
      }

      if (operationHasMutations(operation)) {
        return response;
      }
      /** if it is not expected error then throw it without further processing  */
      throw errors[0];
    }

    return response;
  });
});

export default elevateGqlErrorsLink;
